import { SearchBar, SearchBarContainer } from "./searchbar-loader.styles";

const SearchBarLoader: React.FC = () => (
  <SearchBarContainer>
    <SearchBar />
  </SearchBarContainer>
);

export { SearchBarLoader };
